import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { Card } from '@savgroup-front-common/core/atoms/Cards';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Card = styled(Card)<{ isCliquable?: boolean }>`
  width: 100%;
  @media ${media.maxWidth.sm} {
    padding: ${spacing('lg')};
  }

  transition: 0.15s transform ease-in-out;
  backface-visibility: hidden;
  margin-bottom: ${spacing('lg')};
  margin-top: unset !important;
  -webkit-font-smoothing: antialiased;

  ${({ isCliquable }) =>
    isCliquable
      ? `
    &:hover {
      transform: scale3d(1.015, 1.015, 1);
    }
  `
      : ''}
`;

export const $CardContent = styled.div`
  display: flex;
  align-items: center;
  padding: 0 calc(${spacing('lg')} - 2px);
  justify-content: space-between;

  @media ${media.maxWidth.xs} {
    padding: unset;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const $Divider = styled.div`
  width: calc(100% + ${spacing(7)});
  height: ${spacing('px')};
  background: ${({ theme }) => theme.colors.default};
  margin: ${spacing('xs')} -${spacing('lg')} ${spacing(5)};
`;
